import { SettingScreen } from './types'

export const MY_ACCOUNT_ITEMS = [
  { key: SettingScreen.Account, label: 'Account', admin: false },
  { key: SettingScreen.ProfileDirectory, label: 'Profile', admin: false },
  { key: SettingScreen.MembershipCard, label: 'Membership Card', admin: false },
  // { key: 'profile_public', label: 'Public Profile', admin: false },
  // { key: 'apps', label: 'Connected Apps', admin: false },
  { key: SettingScreen.Notifications, label: 'Notifications', admin: false },
]

export const WORKSPACE_ITEMS = [
  { key: SettingScreen.General, label: 'General', admin: true },
  { key: SettingScreen.Members, label: 'Members', admin: true }, // TODO: remove admin restriction when we create new page
  { key: SettingScreen.Billing, label: 'Billing', admin: false },
  { key: SettingScreen.Styles, label: 'Document Styles', admin: true },
  { key: SettingScreen.Security, label: 'Security', admin: true },
  { key: SettingScreen.Properties, label: 'Properties', admin: true },
]

export const DANGER_ZONE_ITEMS = [{ key: SettingScreen.DangerZone, label: 'Danger Zone', admin: false }]

export const SETTINGS_DEFAULT_SCREEN = SettingScreen.Account // TODO: update this to 'members' once non-admin members view is implemented

export const ALL_ITEMS = [...MY_ACCOUNT_ITEMS, ...WORKSPACE_ITEMS, ...DANGER_ZONE_ITEMS]
